export default __webpack_public_path__ + "static/media/Refresh-Professional-Painting-Service2.759511d0.png";